import { all, takeLatest } from "redux-saga/effects";
import { ACCOUNT_VERIFICATION_REQUEST } from "../SelfSignUp/constants";
import { verifyEmailSuccess, verifyEmailFailure } from "./actions";
import { apiSaga } from "sagas";
import { verifyRegistration } from "utils/api";

export function* accountVerificationFlow(payload) {
  yield* apiSaga(verifyRegistration, [payload], verifyEmailSuccess, verifyEmailFailure);
}

export default function* watchVerification() {
  yield all([
    takeLatest(ACCOUNT_VERIFICATION_REQUEST, accountVerificationFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/containers/ConfirmEmailPage/sagas.js